module.exports = __webpack_public_path__ + "img/btn_md_sign-up.a36f991.png";